import { useEffect, FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateLogin, updateLogout } from '../api-integration/commonSlice';
import PropTypes from 'prop-types';

interface GuestGuardProps {
  children: ReactNode;
}

const NonAuthGuard: FC<GuestGuardProps> = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const redirectURL = sessionStorage.getItem("redirectURL");
  const redirectInProgress = sessionStorage.getItem("redirectInProgress");
  const { isLoggedIn } = useSelector((state: any) => state.commonSlice);

  // removed local storage initialization

  const isSocialNetworkConnection = location.pathname.includes('/external');

  // If NOT logged in or social network connection, allow access
  if (!isLoggedIn || isSocialNetworkConnection) {
    return <>{children}</>;
  }

  // Allow if redirect is happening
  if (redirectURL && redirectInProgress) {
    return <Navigate to={redirectURL} replace />;
  }

  // Logged in & NO redirect → block access to non-auth pages
  return <Navigate to="/home" replace />;
};

NonAuthGuard.propTypes = {
  children: PropTypes.node,
};

export default NonAuthGuard;